import { unionState } from "@common/store/helpers"
import qs from "qs"
const state = () => ({
  installers: [],
  departments: [],
  items: [],
  tempUserData: null,
  showcase: [],
})

const actions = {
  fetch({ commit }, { id }) {
    return axios.get(`/installer-directory/${id}`).then((response) => {
      commit("storeItem", response.data)
    })
  },
  search({ commit }, queryParams) {
    return axios
      .get(`/installer-directory/search`, {
        params: queryParams,
        paramsSerializer: (params) => {
          return qs.stringify(params)
        },
      })
      .then((response) => {
        commit("storeInstallers", response.data.items)
        return response.data
      })
  },
  fetchDepartmentCount({ commit }, params) {
    return axios
      .get(`/installer-directory/department-count`)
      .then((response) => {
        commit("storeDepartments", response.data)
      })
  },
  fetchDepartmentsProjectsCount({ commit }, filters) {
    let departmentIds, departmentCodes, live, acceptedQuote, origins
    if (filters) {
      departmentIds = filters.departmentIds
      departmentCodes = filters.departmentCodes
      live = filters.live
      acceptedQuote = filters.acceptedQuote
      origins = filters.origins
    }
    return axios
      .get(`/departments/projects-count`, {
        params: {
          ids: departmentIds,
          codes: departmentCodes,
          live,
          acceptedQuote,
          origins,
        },
        paramsSerializer: (params) => {
          return qs.stringify(params)
        },
      })
      .then((response) => {
        commit("storeDepartments", response.data)
      })
  },
  async register({ commit }, { params, type, slug }) {
    return await axios.post(`installer-hosted-pages/${slug}/onboard`, params)
  },

  async salesMeetingRequest({ commit }, { slug, params }) {
    return await axios.post(
      `installer-hosted-pages/${slug}/sales-meeting`,
      params,
    )
  },
  storeTempUserData({ commit }, userData) {
    commit("storeTempUserData", userData)
  },
  fetchShowcase({ commit }, { listingId }) {
    return axios
      .get(`/installer-directory/${listingId}/showcase`)
      .then((response) => {
        commit("storeShowcase", response.data)
        return response.data
      })
  },
}

const mutations = {
  storeInstallers(state, installers) {
    state.installers = [...installers]
  },
  storeItem(state, item) {
    state.items = unionState(state.items, [item])
  },
  storeDepartments(state, departments) {
    state.departments = [...departments]
  },
  storeTempUserData(state, userData) {
    state.tempUserData = userData
  },
  storeShowcase(state, showcase) {
    state.showcase = [...showcase]
  },
}

const getters = {
  getTempUserData: (state) => state.tempUserData,
  getShowcase: (state) => state.showcase,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
